export const SonsandCharitiesActions = {
  GET_SONSANDCHARITIES_SECTION: "GET_SONSANDCHARITIES_SECTION",
  SET_SONSANDCHARITIES_SECTION: "SET_SONSANDCHARITIES_SECTION",
};
